import Loading from '../../../components/Loading';
import useViewSupport from './useViewSupport';
import SupportForm from '../components/SupportForm';

export default function ViewMessageSupport() {
    const {
        isLoading,
        data,
        handleStatusChange
    } = useViewSupport();

    return (
        <Loading loading={isLoading} >
            <SupportForm support={data} key={data?.id} onHandleStatusChange={handleStatusChange} />
        </Loading>
    )
}
